import React from "react";
import "./notion-styles.css";
import "./App.css";
// import "react-notion-x/src/styles.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { NotionPage } from "./pages/NotionPage.page";
import { Home } from "./pages/Home.page";
import { Toaster } from "react-hot-toast";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  // TODO: More concise way to write these routes?
  {
    path: "/site/edit/:siteHash",
    element: <NotionPage editable />,
  },
  {
    path: "/site/edit/:siteHash/:pageId",
    element: <NotionPage editable />,
  },
  {
    path: "/site/:siteHash",
    element: <NotionPage />,
  },
  {
    path: "/site/:siteHash/:pageId",
    element: <NotionPage />,
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}

export default App;
